import React, { useState, useEffect } from "react";
import Modal from "../../../components/modal";
import { Minus } from "lucide-react";
import moment from "moment";

const CompanyTenderForm = ({ show, onClose, heading, initialData = {}, onSubmit, customers, products, rawProducts, type }) => {

    const [selectedRawProduct, setSelectedRawProducst] = useState([]);
    const [selectedFinalProduct, setSelectedFinalProduct] = useState([]);
    const [selectedPrice, setSelectedPrice] = useState('');
    const [formData, setFormData] = useState({
        title: '',
        customer_id: '',
        final_product_id: '',
        quantity: '',
        date: '',
        sale_cost: '',
        final_cost: '',
        notes: [{ user_id: "", note: "" }],
        extra_amounts: [{ description: "", amount: "" }],
        discount_type: "",
        discount: "",
        reference_number: '',
        item_description: '',
        delivery_note: '',
        proposed_delivery_date: '',
        is_show_delivery: 0,
        freight: '',
        payment_terms: [{ terms: ""}],
        validity: 0,
        guarantee: "",
        cost_note: [{ user_id: localStorage.getItem('user_id'), note: "" }],

    });

    // Load initial data into form if editing an existing tender
    useEffect(() => {
        if (initialData) {
            // console.log('dsfsfs', initialData);
            setFormData({
                title: initialData.title || '',
                customer_id: initialData.customer_id || '',
                final_product_id: initialData.final_product_id || '',
                quantity: initialData.quantity || '',
                date: initialData.date ? new Date(initialData.date).toISOString().split('T')[0] : '',
                sale_cost: (calculateDiscount(((initialData.finalProduct?.sale_cost * (initialData.gst_included ? 1 : (1 + (initialData.finalProduct?.FinalCategory?.gst || 0) / 100))) * initialData.quantity), initialData.discount_type, initialData.discount)) || '',
                final_cost: initialData.final_cost || "",
                notes: initialData.notes ? JSON.parse(initialData.notes).map((note) => ({
                    user_id: note.user_id, // If user_id is missing, use the creator's user_id
                    note: note.note
                })) : [{ user_id: "", note: "" }],
                extra_amounts: initialData.extra_amounts?.length > 0 ? JSON.parse(initialData.extra_amounts) : [{ description: "", amount: "" }],
                reference_number: initialData.reference_number || '',
                item_description: initialData.item_description || '',
                delivery_note: initialData.delivery_note || '',
                discount_type: initialData.discount_type || '',
                discount: initialData.discount || '',
                proposed_delivery_date: initialData.proposed_delivery_date ? new Date(initialData.proposed_delivery_date).toISOString().split('T')[0] : '',
                is_show_delivery: initialData.is_show_delivery?true:false,
                freight: initialData.freight || '',
                payment_terms: initialData.payment_terms?.length > 0? JSON.parse(initialData.payment_terms) : [{ terms: "" }],
                validity: initialData.validity || 0,
                guarantee: initialData.guarantee || '',
                cost_note: initialData.TenderNotes?.length > 0 ? initialData.TenderNotes.map((cnote) => ({
                    user_id: cnote.user_id, note: cnote.note 
                })) : [{ user_id: localStorage.getItem('user_id'), note: "" }],
            });

            const selectedProduct = products.find(product => product.id == initialData.final_product_id);
            setSelectedFinalProduct(selectedProduct || []);
        }
    }, [initialData]);


    const calculateDiscount = (sale_cost, discount_typeData, discountData) => {
        let totalAmount =  sale_cost;
        const discount = discountData;
        const discountType = discount_typeData;
        if (discountType === "percentage") {
            totalAmount -= (totalAmount * discount) / 100;
        } else if (discountType === "flat") {
            totalAmount -= discount;
        }
        return totalAmount
    }
    // Handle input changes
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (name === "final_product_id") {
            const selectedProduct = products.find(product => product.id == value);
            setSelectedFinalProduct(selectedProduct || []);
            if (selectedProduct) {
                
                console.log('this is sellected ', selectedProduct);
                const rawProducts = selectedProduct.raw_products ? JSON.parse(selectedProduct.raw_products) : [];

                setSelectedPrice(selectedProduct.sale_cost);
                setFormData({
                    ...formData,
                    final_product_id: value,
                });
                if (rawProducts.length > 0) {
                    const firstRawProduct = rawProducts[0];
                    if (firstRawProduct && firstRawProduct.id) {
                        setSelectedRawProducst(rawProducts);
                    } else {
                        setSelectedRawProducst([]);
                    }
                } else {
                    setSelectedRawProducst([]);
                }
            }
        } else if (name == 'quantity') {
            setFormData({
                ...formData,
                [name]: value,
            });

        } else if(name == 'discount' && formData.discount_type != '') {
            let totalAmount =  ((initialData.finalProduct?.sale_cost * (initialData.gst_included ? 1 : (1 + (initialData.finalProduct?.FinalCategory?.gst || 0) / 100))) * initialData.quantity);
            const discount = parseFloat(value) || 0;
            const discountType = formData.discount_type;
            console.log('totla', totalAmount);
            if (discountType === "percentage") {
                totalAmount -= (totalAmount * discount) / 100;
            } else if (discountType === "flat") {
                totalAmount -= discount;
            }
            setFormData({
                ...formData,
                [name]: value,
                sale_cost: totalAmount.toFixed(2),
                final_cost: totalAmount.toFixed(2),
            });
        }else if(type == 'checkbox') {
            setFormData({ ...formData, [name]: checked?1:0 });
        }else {
            setFormData({ ...formData, [name]: value });
        }
    };


    // Handle adding a new note
    const handleAddNote = () => {
        setFormData({
            ...formData,
            notes: [...formData.notes, { user_id: "", note: "" }] // Assign the current user's ID
        });
    };

    // Handle removing a note
    const handleRemoveNote = (index) => {
        const updatedNotes = formData.notes.filter((_, i) => i !== index);
        setFormData({ ...formData, notes: updatedNotes });
    };

    // Handle note change
    // const handleNoteChange = (index, value) => {
    //     const updatedNotes = formData.notes.map((note, i) => (i === index ? value : note));
    //     setFormData({ ...formData, notes: { user_id: "", note: updatedNotes} });
    // };

    const handleNoteChange = (index, value) => {
        setFormData((prevData) => ({
            ...prevData,
            notes: prevData.notes.map((note, i) =>
                i === index ? { user_id: "", note: value } : note
            ),
        }));
    };



    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        // Convert notes array to JSON string for submission
        const dataToSubmit = { ...formData, created_by: localStorage.getItem('user_id'), notes: JSON.stringify(formData.notes) };
        // console.log('submitted data ', dataToSubmit);
        onSubmit(dataToSubmit);
    };


    const handleExtraAmountChange = (index, e) => {
        const updatedExtraAmounts = [...formData.extra_amounts];
        updatedExtraAmounts[index][e.target.name] = e.target.value;
        setFormData({ ...formData, extra_amounts: updatedExtraAmounts });
        if(e.target.name == 'amount'){
            calcuateFinalCost(formData.sale_cost);
        }
    };

    const calcuateFinalCost = (sale_cost) => {
        let extra = 0;
        const sale = sale_cost;
        formData.extra_amounts.map((e) => extra += parseInt(e.amount));
        setFormData({ ...formData, final_cost: parseFloat(sale) + extra });

    }

    const removeExtraAmount = (index) => {
        const updatedExtraAmounts = formData.extra_amounts.filter((_, i) => i !== index);
        setFormData({ ...formData, extra_amounts: updatedExtraAmounts });
    };
    // Add new extra amount row
    const addExtraAmount = () => {
        setFormData({ ...formData, extra_amounts: [...formData.extra_amounts, { description: "", amount: "" }] });
    };

    // Handle payment terms change
    const handlePaymentTermsChange = (index, e) => {
        const updatedPaymentTerms = [...formData.payment_terms];
        updatedPaymentTerms[index][e.target.name] = e.target.value;
        setFormData({ ...formData, payment_terms: updatedPaymentTerms });
    };

    // Add new payment terms row
    const addPaymentTerm = () => {
        setFormData({ ...formData, payment_terms: [...formData.payment_terms, { terms: "" }] });
    };

    const removePaymentTerm = (index) => {
        const updatedPaymentTerm = formData.payment_terms.filter((_, i) => i !== index);
        setFormData({ ...formData, payment_terms: updatedPaymentTerm });
    };

    const addCostNote = () => {
        setFormData({
            ...formData,
            cost_note: [...formData.cost_note, { user_id: localStorage.getItem('user_id'), note: "" }]
        });
    };
    
    const handleCostNoteChange = (index, e) => {
        const { name, value } = e.target;
        const updatedCostNotes = [...formData.cost_note];
        updatedCostNotes[index][name] = value;
        setFormData({ ...formData, cost_note: updatedCostNotes });
    };
    
    const removeCostNote = (index) => {
        const updatedCostNotes = formData.cost_note.filter((_, i) => i !== index);
        setFormData({ ...formData, cost_note: updatedCostNotes });
    };
    


    return (
        <Modal
            show={show}
            onClose={onClose}
            heading={heading}
        >
            <form onSubmit={handleSubmit}>
                <div className="row">
                    {/* Customer Selection */}
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Title</label>
                            <input type="text" name="title" className="form-control" value={formData.title} onChange={handleChange} />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Customer</label>
                            <select
                                onChange={handleChange}
                                value={formData.customer_id}
                                required
                                name="customer_id"
                                className="form-control"
                            >
                                <option value="">Select Customer</option>
                                {customers.map((customer) => (
                                    <option key={customer.id} value={customer.id}>
                                        {customer.name} ({customer.company_name})
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Delivery Date</label>
                            <input
                                type="date"
                                name="date"
                                className="form-control"
                                value={formData.date}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>
                    {initialData && initialData.createdAt && (<div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Sale Creation Date</label>
                            <input
                                type="text"
                                className="form-control"
                                value={moment(initialData?.createdAt).format('DD/MM/YYYY')}
                                onChange={handleChange}
                                readOnly
                            />
                        </div>
                    </div>)}

                    {/* Final Product Selection */}
                    <div className="col-md-4">
                        <div className="form-group mb-4">
                            <label>Final Product</label>
                            <select
                                onChange={handleChange}
                                value={formData.final_product_id}
                                required
                                name="final_product_id"
                                className="form-control"
                            >
                                <option value="">Select Product</option>
                                {products.map((product) => (
                                    <option key={product.id} value={product.id}>
                                        {product.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* Quantity */}
                    <div className="col-md-4">
                        <div className="form-group mb-4">
                            <label>Quantity</label>
                            <input
                                type="number"
                                name="quantity"
                                min={0}
                                className="form-control"
                                value={formData.quantity}
                                onChange={handleChange}
                                placeholder="Enter quantity"
                                required
                            />
                        </div>
                    </div>

                    {/* Sale Cost */}
                    <div className="col-md-4">
                        <div className="form-group mb-4">
                            <label>Actual Cost / Unit</label>
                            <div className="input-group mb-2">
                                <div className="input-group-prepend">
                                    <div className="input-group-text">₹</div>
                                </div>
                                <input
                                    type="number"
                                    value={
                                        selectedFinalProduct.sale_cost *
                                        (selectedFinalProduct.gst_included ? 1 : (1 + (selectedFinalProduct.FinalCategory?.gst || 0) / 100))
                                    }
                                    readOnly
                                    className="form-control"
                                    onChange={handleChange}
                                    placeholder="Enter sale cost"
                                    required
                                />
                                {selectedFinalProduct && selectedFinalProduct.unit && (<div className="input-group-prepend">
                                    <div className="input-group-text">{selectedFinalProduct.unit}</div>
                                </div>)}
                            </div>
                        </div>
                    </div>
                    {type == 'cost' && (<div className="col-md-4">
                        <div className="form-group mb-4">
                            <label>Discount Type</label>
                            <select
                                name="discount_type"
                                className="form-control"
                                value={formData.discount_type}
                                onChange={handleChange}
                            >
                                <option value="">Select Discount Type</option>
                                <option value="percentage">Percentage</option>
                                <option value="flat">Flat</option>
                            </select>
                        </div>
                    </div>)}

                    {/* Discount */}
                    {type == 'cost' && (<div className="col-md-4">
                        <div className="form-group mb-4">
                            <label>Discount</label>
                            <div className="input-group mb-2">
                                {formData.discount_type && (<div className="input-group-prepend">
                                    <div className="input-group-text">{formData.discount_type == 'percentage' ? '%' : '₹'}</div>
                                </div>)}
                                <input
                                    type="number"
                                    name="discount"
                                    className="form-control"
                                    value={formData.discount}
                                    onChange={handleChange}
                                    placeholder="Enter Discount"
                                />
                            </div>
                        </div>
                    </div>)}
                    {type == 'cost' && (<div className="col-md-4">
                        <div className="form-group mb-4">
                            <label>Sale Cost</label>
                            <div className="input-group mb-2">
                                <div className="input-group-prepend">
                                    <div className="input-group-text">₹</div>
                                </div>
                                <input
                                    type="number"
                                    name="sale_cost"
                                    readOnly
                                    className="form-control"
                                    value={formData.sale_cost}
                                    onChange={handleChange}
                                    placeholder="Enter sale cost"
                                    required
                                />
                            </div>
                        </div>
                    </div>)}


                    {type == 'cost' && (<div className="col-md-12 mb-3">
                        <label className="form-label w-100">Extra Amounts
                            <button type="button" className="btn btn-primary btn-sm float-end" onClick={addExtraAmount}>+ Add Extra Amount</button>
                        </label>
                        {formData.extra_amounts.map((extra, index) => (
                            <div key={index} className="d-flex mb-2">
                                <input
                                    type="text"
                                    name="description"
                                    placeholder="Description"
                                    value={extra.description}
                                    onChange={(e) => handleExtraAmountChange(index, e)}
                                    className="form-control me-2"
                                />
                                
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text">₹</div>
                                    </div>
                                    <input
                                        type="number"
                                        name="amount"
                                        placeholder="Amount"
                                        value={extra.amount}
                                        onChange={(e) => handleExtraAmountChange(index, e)}
                                        className="form-control me-2"
                                    />
                                </div>
                                <button
                                    type="button"
                                    className="btn btn-danger btn-sm"
                                    onClick={() => removeExtraAmount(index)}
                                >
                                    <Minus />
                                </button>
                            </div>
                        ))}
                        
                    </div>)}

                    {type == 'cost' && (<div className="col-md-4">
                        <div className="form-group mb-4">
                            <label>Final Cost</label>
                            <div className="input-group mb-2">
                                <div className="input-group-prepend">
                                    <div className="input-group-text">₹</div>
                                </div>
                                <input
                                    type="number"
                                    name="final_cost"
                                    className="form-control"
                                    value={formData.final_cost}
                                    onChange={handleChange}
                                    placeholder="Enter sale cost"
                                    required
                                />
                            </div>
                        </div>
                    </div>)}

                    {type == 'cost' && (<div className="col-md-4">
                        <div className="form-group mb-4">
                            <label className="form-label">Reference Number</label>
                            <input type="text" name="reference_number" value={formData.reference_number} onChange={handleChange} className="form-control" />
                        </div>
                    </div>)}

                    {type == 'cost' && (
                        <div className="col-md-4">
                            <div className="mb-3">
                                <label className="form-label">Proposed Delivery Date</label>
                                <input type="date" name="proposed_delivery_date" value={formData.proposed_delivery_date} onChange={handleChange} className="form-control" />
                            </div>
                        </div>
                    )}

                    {type == 'cost' && (<div className="col-md-12">
                        <div className="form-group mb-4">
                            <label className="form-label">Item Description</label>
                            <textarea name="item_description" value={formData.item_description} onChange={handleChange} className="form-control" />
                        </div>
                    </div>)}

                    <div className="mb-3">
                        <label className="form-label">Delivery Note</label>
                        <textarea name="delivery_note" value={formData.delivery_note} onChange={handleChange} className="form-control" />
                    </div>

                    

                    {type == 'cost' && (<div className="mb-3">
                        <input type="checkbox" name="is_show_delivery" value={formData.is_show_delivery == 1?true:false} onChange={handleChange}/>
                        <label className="form-label"> &nbsp; &nbsp; Show delivery date with the number of weeks required?</label>
                    </div>)}

                    {type == 'cost' && (<div className="mb-3">
                        <input type="checkbox" name="freight" checked={formData.freight == 1?true:false} onChange={handleChange} />
                        <label className="form-label">  &nbsp;  &nbsp; Freight Included?</label>
                    </div>)}

                    {type == 'cost' && (
                        <div className="col-md-3">
                            <div className="form-group mb-3">
                                <label className="form-label">Validity (Days)</label>
                                <div className="input-group mb-2">
                                    
                                    <input type="number" name="validity" value={formData.validity} onChange={handleChange} className="form-control" />
                                    <div className="input-group-prepend">
                                        <div className="input-group-text">Days</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {type == 'cost' && (
                        <div className="col-md-9">
                            <div className="mb-3">
                                <label className="form-label">Guarantee</label>
                                <input type="text" name="guarantee" value={formData.guarantee} onChange={handleChange} className="form-control" />
                            </div>
                        </div>
                    )}

                    {/* Date */}


                    {/* Notes */}
                    <div className="col-md-12">
                        <div className="form-group mb-4">
                            <label className="w-100">
                                {type == 'cost'?"Sales Notes":"Notes"}
                                {type != 'cost' && (<button
                                    type="button"
                                    className="btn btn-success float-end"
                                    onClick={handleAddNote}
                                >
                                    Add Note
                                </button>)}
                            </label>
                            {formData.notes.map((note, index) => (
                                <div key={index} className="d-flex mb-2">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={note.note}
                                        readOnly={note.user_id != ""}
                                        onChange={(e) => handleNoteChange(index, e.target.value)}
                                        placeholder="Enter note"
                                        rows="1"
                                    />
                                    {note.user_id == "" && (<button
                                        type="button"
                                        className="btn btn-danger ms-2"
                                        onClick={() => handleRemoveNote(index)}
                                    >
                                        <Minus />
                                    </button>)}
                                </div>
                            ))}

                        </div>
                    </div>
                    {/* <div className="col-md-12">
                        <div className="form-group mb-4">
                            <label className="w-100">Raw Products</label>
                            {formData.final_product_id && selectedRawProduct.length > 0  && selectedRawProduct.map((prod, ind) => {
                                const selectRaw = rawProducts.find((p) => p.id == prod.id);
                                let quantity_all = 0;
                                let lowestCost = 0;

                                if (selectRaw) {
                                    const vendorQuantities = selectRaw.RawProductVendors?.map((s) => s.quantity) || [];
                                    const vendorCosts = selectRaw.RawProductVendors?.map((s) => s.purchase_cost) || [];

                                    // Calculate total quantity
                                    quantity_all = vendorQuantities.reduce((total, qty) => total + qty, 0);

                                    // Calculate lowest cost from vendorCosts array
                                    if (vendorCosts.length > 0) {
                                        lowestCost = Math.min(...vendorCosts);
                                    }
                                }

                                return (
                                    <div key={ind} className="row" style={{
                                        paddingTop: "10px",
                                        borderBottom: '1px solid rgb(193 178 178)'
                                    }}>
                                        <div className="col-md-6">
                                            {selectRaw ? (
                                                <>
                                                    <h4>{selectRaw.name}</h4>
                                                    <p><strong>Current Stock:</strong> {quantity_all}</p>
                                                    <p><strong>Average Total Cost:</strong> ₹ {lowestCost * (prod.quantity * formData.quantity)}</p>
                                                    <p className={`${quantity_all < (prod.quantity * formData.quantity)?'text-danger':'text-success'}`}><strong>Required Quantity:</strong> {prod.quantity * formData.quantity}</p>

                                                </>
                                            ) : (
                                                <p>Product not found</p>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}

                        </div>
                    </div> */}

                    {type == 'cost' && (
                        <div className="mb-3">
                            <label className="form-label w-100">Payment Terms
                            <button type="button" className="btn btn-primary btn-sm float-end" onClick={addPaymentTerm}>+ Add Payment Term</button>
                            </label>
                            {formData.payment_terms.map((term, index) => (
                                <div key={index} className="d-flex mb-2">
                                    <input
                                        type="text"
                                        name="terms"
                                        placeholder="Payment Terms"
                                        value={term.terms}
                                        onChange={(e) => handlePaymentTermsChange(index, e)}
                                        className="form-control me-2"
                                    />
                                    <button type="button" className="btn btn-danger btn-sm" onClick={() => removePaymentTerm(index)}>
                                        <Minus/>
                                    </button>
                                </div>
                            ))}
                            
                        </div>
                    )}

                    {type == 'cost' && (<div className="mb-3">
                        <label className="form-label w-100">
                            Your Note
                            <button type="button" className="btn btn-primary btn-sm float-end" onClick={addCostNote}>
                                + Add Cost Note
                            </button>
                        </label>

                        {formData.cost_note.map((note, index) => (
                            <div key={index} className="d-flex mb-2">
                                <input
                                    type="text"
                                    name="note"
                                    placeholder="Note"
                                    value={note.note}
                                    onChange={(e) => handleCostNoteChange(index, e)}
                                    className="form-control me-2"
                                />
                                <button type="button" className="btn btn-danger btn-sm" onClick={() => removeCostNote(index)}>
                                    <Minus/>
                                </button>
                            </div>
                        ))}
                    </div>)}
                </div>

                <div className="d-flex justify-content-end">
                    <button
                        type="button"
                        className="btn btn-light me-2"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">
                        Save
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default CompanyTenderForm;
